<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >


            <el-form-item label="活动期次">
                <el-select v-model="formInline.bindCode"  placeholder="活动期次">
                    <el-option
                            v-for="item in activeList"
                            :key="item.bindCode"
                            :label="item.activeName"
                            :value="item.bindCode">
                    </el-option>
                </el-select>

                <el-button type="success" @click="queryList">查询</el-button>

            </el-form-item>
        </el-form>

        <el-table :data="getDataList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="activeName" label="活动期次" width="120"></el-table-column>
            <el-table-column prop="productName" label="兑换物资" width="110"></el-table-column>
            <el-table-column prop="total" label="总库存" width="110"></el-table-column>
            <el-table-column prop="remain" label="剩余库存" width="110"></el-table-column>


            <el-table-column prop="createTime" label="创建时间" width=""></el-table-column>
            <el-table-column prop="updateTime" label="最新更新时间" width=""></el-table-column>


            <el-table-column label="操作" fixed="right" width="290">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">修改</el-button>


                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <!-- 新增批次window -->
        <el-dialog title="新增" :visible.sync="dialogFormVisible" center  center top="5vh">
            <el-form :model="form" label-width="120px" size="small ">
                <el-form-item label="活动期次" :required="true">
                    <el-input v-model="form.activeName" placeholder="活动期次" disabled></el-input>
                </el-form-item>
                <el-form-item label="兑换物品" :required="true">
                    <el-input v-model="form.productName" placeholder="兑换物品" disabled ></el-input>
                </el-form-item>
                <el-form-item label="库存总数" :required="true">
                    <el-input v-model="form.total" placeholder="库存总数" disabled ></el-input>
                </el-form-item>
                <el-form-item label="剩余库存" :required="true">
                    <el-input v-model="form.remain" placeholder="剩余库存" disabled ></el-input>
                </el-form-item>
                <el-form-item label="增加库存数" :required="true">
                    <el-input v-model="form.addStock" type="number"  placeholder="增加库存数" maxlength="11" clearable ></el-input>
                    备注：减少库存请使用负数
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddData(form)">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {saveStock,getStockList} from '@/api/api';
    import {getActiveList} from "../../api/api";

    export default {
        data() {
            return {
                showDialog: false,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                getDataList: [],// 批次信息

                loading: true,
                form: {
                    stockId:null,
                    bindCode: '',
                    reunionSiteId: 0,
                    productId:null,
                    total: null,
                    remain: null,
                    createTime:'',
                    updateTime:'',
                    activeName:'',
                    productName:'',
                    addStock:0

                },
                formInline: {
                    bindCode:'',
                    pageNum: 1,
                    pageSize: 30,
                    recordsTotal: 0
                },
                formSearch: {
                    status:1,
                    activeType:30,
                    currentPage: 1,
                    pageSize: 100,
                    recordsTotal: 0
                },
                activeList:[]
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.queryActiveList();
            this.queryDataList();

            //console.log(this.options)
        },
        methods: {

            queryDataList(){
                this.loading = true;
                getStockList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.getDataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //查询
            queryList(){
                this.queryDataList();
                this.formInline.currentPage = 1
            },

            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryDataList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryDataList();
            },
            queryActiveList(){
                this.loading = true;
                getActiveList(this.formSearch).then((res) => {
                    console.log(res);
                    this.loading = false;
                    if (res.data.status == 200) {

                        this.activeList = res.data.value.list;
                        this.formInline.bindCode=this.activeList[0].bindCode;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //新增事件
            addData() {
                this.form = {
                    stockId:null,
                    bindCode: '',
                    reunionSiteId: 0,
                    productId:null,
                    total: null,
                    remain: null,
                    createTime:'',
                    updateTime:'',
                    activeName:'',
                    productName:'',
                    addStock:0
                }

                this.dialogFormVisible = true;
            },

            //修改事件
            handleUpdate(row) {
                this.form = {
                    stockId:row.stockId,
                    bindCode: row.bindCode,
                    reunionSiteId: row.reunionSiteId,
                    productId:row.productId,
                    total: row.total,
                    remain: row.remain,
                    createTime:row.createTime,
                    updateTime:row.updateTime,
                    activeName:row.activeName,
                    productName:row.productName,
                    addStock:row.addStock
                }
                this.dialogFormVisible = true;
            },


            //确定事件
            updateOrAddData(form) {


                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveStock(form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.queryDataList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .customer-id{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/reunion/ReunionStock.vue